// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"60a68dc5","453":"76cbe3dc","796":"3a452e1c"}[chunkId] + ".chunk.js";
};